import React from 'react';
import { ZakekeLoadingIcon } from '../svg/zakekeLoadingIcon';
import { FC } from 'react';
import styled from 'styled-components';

const _ZakekeLoading: FC<{ className?: string }> = ({ className }) => {
    return <ZakekeLoadingIcon className={className} />;
};

export const ZakekeLoading = styled(_ZakekeLoading)`
    transform: scale(0.45);
`;
